module.exports = (__webpack_require__(6959))(3671);